import { render } from "./SurveyQuestion1.vue?vue&type=template&id=0f4596fa"
import script from "./SurveyQuestion1.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion1.vue?vue&type=script&lang=js"

import exportComponent from "/home/danujaf/development/customer-survey/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__